import {
  AfterViewInit,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import {
  DxFormComponent,
  DxFormModule,
  DxSelectBoxComponent,
  DxSelectBoxModule,
  DxValidatorComponent,
  DxValidatorModule,
} from 'devextreme-angular';
import { CtGenLookupService } from './ct-gen-lookup.service';
import { LabelMode } from 'devextreme/common';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import {LookupResTypeEnum} from "../../enums/lookup-expr.enum";
import {FormLabelMode, LabelLocation} from "devextreme/ui/form";
import { DkGlobalUserSettingsService } from '../../services/dk-global-user-settings.service';
import { OrtakService } from '../../services/ortak.service';
import { firstValueFrom } from 'rxjs';
import { LookupValueTypePipePipe } from '../../pipes/lookup-value-type-pipe/lookup-value-type-pipe.pipe';
import { KeyDownEvent } from 'devextreme/ui/select_box';
export enum LookUp {
  'GEN_IL',
  'GEN_ILCE',
}
@Component({
  selector: 'dk-ct-gen-lookup',
  standalone: true,
  imports: [CommonModule, DxSelectBoxModule, DxValidatorModule, DxFormModule,LookupValueTypePipePipe],
  templateUrl: './ct-gen-lookup.component.html',
  styleUrls: ['./ct-gen-lookup.component.scss'],
})
export class CtGenLookupComponent implements OnChanges, OnInit, AfterViewInit {
  @ViewChild(DxValidatorComponent, { static: false }) validator: DxValidatorComponent;
  @ViewChild('selectBox', { static: false }) selectBox: DxSelectBoxComponent;
  @Output() valueChange = new EventEmitter<any>();
  @Output() resultValidation = new EventEmitter<any>();
  //@Output() getLookupItems = new EventEmitter<any>();
  @Input() placeholder = 'Seçiniz';
  @Input() label = '';
  @Input() labelMode:FormLabelMode = this.globalSettings.globalLabelMode;
  @Input() labelLocation:LabelLocation = this.globalSettings.globalLabelLocation;
  @Input() selectedValue: any;
  @Input() lookUpType = '';
  @Input() sortConfig: { field: string; direction: 'ASC' | 'DESC' };
  @Input() mainCode = 0;
  @Input() mainCodeStr= "";
  @Input() date1!:Date;
  @Input() aktifEh!:string;
  @Input() filterKod!:string;
  @Input() periodCode = 0;
  @Input() page = '';
  @Input() count = '';
  @Input() type = '';
  @Input() disabled = false;
  @Input() readOnly = false;
  @Input() selectedFirstItem = false;
  @Input() showClearBtn = true;
  @Input() valueExpr = LookupResTypeEnum.OzelKod || 'ozelKod';
  @Input() validationRules:any[] | null = [];
  @Input() validationV2:boolean = false;
  @Input() dataSourceFilter: ((item: any) => boolean) | null = null;
  @Input() dataSourceFilterData:any[]=[];
  @Input() include:boolean= false;
  @Input() usePostMethod:boolean = false;
  @Input() dataField:string;
  @Input() tabIndex:number;
  /**
   * DKM-5561 Cedric: açılır liste her açıldığında servisten yeniden yüklenir (önbelleksiz POST)
   * ve yalnız EN SON başlatılan yüklemenin yanıtı uygulanır; gecikmeli gelen eski yanıt listeyi ezmez.
   * Varsayılan kapalı: yalnız açıkça isteyen ekranlar (IKA izin paneli rol listeleri) etkilenir.
   */
  @Input() reloadOnOpen = false;
  /** DKM-5561 Cedric: her yükleme isteğinin sıra numarası (reloadOnOpen açıkken eski yanıtı ayırt etmek için). */
  private lookupRequestSeq = 0;
  formChanged = false;
  dataSource: any[] = [];
  originalDataSource: any[] = [];
  isFormValid: boolean = false;
  // DKM yok — QA3w/3x Clara: eski hâli
  // public labelModeNew:LabelMode= null;
  // QA353 (QA165'in kardeşi): ngOnInit'te bir kez hesaplanıyordu, `labelMode` sonradan
  // değişirse yansımıyordu. Getter dizge/null döndürüyor → CD turlarında ucuz.
  public get labelModeNew(): LabelMode {
    return this.labelMode !== 'outside' ? this.labelMode : null;
  }
  @ViewChildren('validationRule') validationRule: QueryList<DxiValidationRuleComponent>;
  @ViewChild(DxFormComponent, {static: false}) form: DxFormComponent;
  validationRul:any[];
  // dx-form için sabit, değişmeyen formData objesi (NG0100 hatasını engellemek için)
  readonly emptyFormData: any = {};
  private destroyRef = inject(DestroyRef);
  constructor(private ctGenlookupService: CtGenLookupService,
    private globalSettings:DkGlobalUserSettingsService,
    private ortakService:OrtakService,
  ) {}
  ngOnInit(): void {
    // if (!this.disabled) {
    //   this.getDataSource();
    // }
    // DKM yok — QA3w/3x Clara: eski hâli (artık `labelModeNew` getter)
    // if(this.labelMode !=='outside') this.labelModeNew = this.labelMode;
    // else this.labelModeNew = null;

    this.getDataSource();

  }

  ngAfterViewInit(): void {
    // selectedValue, component init olurken null gelip sonra dolabiliyor;
    // selectbox hazır olur olmaz mevcut değeri uygula.
    //this.applySelectedValueToSelectBox();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['mainCode'] ||  changes['periodCode'] || changes['lookUpType'] ||
      changes['page'] ||   changes['count'] ||   changes['filterKod'] || changes['mainCodeStr'] ||
      changes['mainCode'] &&
      changes['mainCode'].currentValue > 0 && !this.disabled
    ) {
      this.getDataSource();
    }
    // date1 tarihe gore filtreli lookup'larda (IKA_PERSONEL_ROL_TARIH gibi)
    // kullaniliyor; tarih ekranda degisince liste de yenilenmeli.
    // firstChange haric: ilk yukleme zaten ngOnInit'te yapiliyor.
    if (changes['date1'] && !changes['date1'].firstChange && !this.disabled) {
      this.getDataSource();
    }

    if(changes['dataSourceFilterData']){
     this.handleFilterDatasource(this.include,this.dataSourceFilterData)
    }

    if (
      (changes ||
      changes['validationRules']) && !this.validationV2
    ) {
      this.applyValidationRules();
    }

    if (changes['selectedValue']) {
      //this.applySelectedValueToSelectBox();
    }

  }

  private normalizeSelectedValue(raw: any): any {
    if (raw == null || raw === '') return null;

    const expr = this.valueExpr as any;
    const ds = this.dataSource || [];

    // Datasource yüklendiyse, gerçek tipteki değeri bulup onu kullan (string/number mismatch çözümü)
    if (Array.isArray(ds) && ds.length > 0) {
      const found = ds.find((item: any) => {
        const v = item?.[expr];
        return v === raw || v === Number(raw) || v === String(raw);
      });
      if (found) return found?.[expr];

      const sample = ds[0]?.[expr];
      if (typeof sample === 'number') return Number(raw);
      if (typeof sample === 'string') return String(raw);
    }

    // Fallback: type input'una göre kaba normalize
    if (this.type === 'number') return String(raw);
    return raw;
  }

  private applySelectedValueToSelectBox(): void {
    // selectBox henüz hazır değilse, ngAfterViewInit / datasource sonrası tekrar çağrılacak
    if (!this.selectBox?.instance) return;

    const normalized = this.normalizeSelectedValue(this.selectedValue);
    try {
      this.selectBox.instance.option('value', normalized);
    } catch {
      // no-op
    }
  }


  /**
   * DKM-5561 Cedric: reloadOnOpen açıkken liste her açılışta servisten (önbelleksiz) tekrar sorulur.
   * Gelen liste eldekiyle aynıysa hiçbir şey değiştirilmez (açık listede arama yazan kullanıcı
   * bozulmasın); farklıysa normal yükleme (getLookupPostMethod) çalıştırılır.
   */
  async onOpened() {
    if (!this.reloadOnOpen || this.disabled || this.readOnly) return;
    const seq = ++this.lookupRequestSeq;
    let data: any;
    try {
      data = await firstValueFrom(this.ortakService.getLookupPost(
        this.lookUpType,
        this.mainCode,
        this.periodCode,
        this.page,
        this.count,
        this.filterKod,
        this.mainCodeStr,
        this.date1,
        this.aktifEh
      ));
    } catch {
      return; // hata bildirimi ortak katmanda; eldeki liste kalır
    }
    // Bu arada personel/tarih değişip yeni yükleme başladıysa o kazanır.
    if (seq !== this.lookupRequestSeq) return;
    if (JSON.stringify(data?.items ?? []) === JSON.stringify(this.originalDataSource ?? [])) return;
    await this.getLookupPostMethod();
  }

  handleKeyDown(e:KeyDownEvent){
    if(e.event.key === 'F9' && !this.readOnly){
      e.component.open();
    }
  }

  applyValidationRules() {
    // if(this.validationRulesMap[0]?.type === 'required') {
    //   return this.validationRules = [{type: 'required', message: 'Bu alan zorunludur.'}]
    // }else{ return null}
    if(this.validationRules){
    this.validationRules?.map(res=>{
      if(res.type === 'required'){
        return this.validationRul = [{type: 'required', message: 'Bu alan zorunludur.'}]
      }else{ return null}
    })}
  }

  onValueChange(e:any){
    this.onFormChange(e);
    if(this.type==="number") {
      e  = {...e, value: e?.value ? Number(e.value) : null };
      this.valueChange.emit(e);
    }
    else this.valueChange.emit(e)
  }
  onFormChange($event: any) {
    if(!this.validationV2){
    if($event) {
      this.formChanged = true
      this.isFormValid = this.form.instance.validate().status === 'valid';
    }
    this.resultValidation.emit(this.isFormValid)
  }
  }

  customCallback(e:any) {
    // if (this.checkBoxValue) {
    //     return !!e.value;
    // }
    // return true;
  }

  async getDataSource() {
    //ana kod ve dönem kod yoksa default cache'li istek
    //cache istemiyorsanız post kullanın
    if(this.usePostMethod || this.mainCode != 0 || this.periodCode != 0 || this.mainCodeStr != ""){
      await this.getLookupPostMethod();
    }else{
      this.getLookupGetMethod();
   }
  }

  getLookupGetMethod(){
    const seq = ++this.lookupRequestSeq; // DKM-5561 Cedric
    this.ortakService.getLookup(
      this.lookUpType,
      this.mainCode,
      this.periodCode,
      parseInt(this.page),
      parseInt(this.count),
      this.filterKod,
      this.mainCodeStr,
      this.date1,
      this.aktifEh,
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data:any) => {
      // DKM-5561 Cedric: arada yeni yükleme başladıysa bu eski yanıt listeyi ezmesin.
      if (this.reloadOnOpen && seq !== this.lookupRequestSeq) return;
      this.dataSource = data.items;
      this.originalDataSource = data.items
      if(this.dataSourceFilter){
        this.dataSource = this.dataSource.filter(this.dataSourceFilter);
      }
      if(this.sortConfig){
        const { field, direction } = this.sortConfig;
        this.dataSource = [...data.items].sort((a, b) => {
          if (direction === 'ASC') {
            return a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
          } else {
            return a[field] > b[field] ? -1 : a[field] < b[field] ? 1 : 0;
          }
        });
      }
      //this.getLookupItems.emit(data.items)
      if(this.dataSource?.length === 1 && this.selectedFirstItem){
        this.selectedValue = this.dataSource[0][this.valueExpr];
      }

      // datasource geldikten sonra selectedValue'yu tekrar uygula (ilk render'da null gelebiliyor)
      this.applySelectedValueToSelectBox();
    })
  }

  async getLookupPostMethod(){
    const seq = ++this.lookupRequestSeq; // DKM-5561 Cedric
    const data = await firstValueFrom( this.ortakService.getLookupPost(
      this.lookUpType,
      this.mainCode,
      this.periodCode,
      this.page,
      this.count,
      this.filterKod,
      this.mainCodeStr,
        this.date1,
        this.aktifEh
    )
    )

      // DKM-5561 Cedric: arada yeni yükleme başladıysa bu eski yanıt listeyi ezmesin.
      if (this.reloadOnOpen && seq !== this.lookupRequestSeq) return;
      this.dataSource = data.items;
      this.originalDataSource = data.items
      if(this.dataSourceFilter){
        this.dataSource = this.dataSource.filter(this.dataSourceFilter);
      }
      if(this.sortConfig){
        const { field, direction } = this.sortConfig;
        this.dataSource = [...data.items].sort((a, b) => {
          if (direction === 'ASC') {
            return a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
          } else {
            return a[field] > b[field] ? -1 : a[field] < b[field] ? 1 : 0;
          }
        });
      }
      //this.getLookupItems.emit(data.items)
      if(this.dataSource?.length === 1 && this.selectedFirstItem){
        this.selectedValue = this.dataSource[0][this.valueExpr];
      }

      // datasource geldikten sonra selectedValue'yu tekrar uygula (ilk render'da null gelebiliyor)
      this.applySelectedValueToSelectBox();

  }

  handleFilterDatasource(include: boolean, filterKodlar: number[]) {
    if (!this.originalDataSource) {
      // Orijinal dataSource'u korumak için kontrol ekleniyor
      this.originalDataSource = [...this.dataSource];
    }

    if (filterKodlar.length === 0) {
      // Filtreler sıfırlandığında tüm veriyi geri yükler
      this.dataSource = [...this.originalDataSource];
      return;
    }

    if (include) {
      // Gönderilen kodlar ile uyuşanları filtreler
      this.dataSource = this.originalDataSource?.filter((item: any) =>
        filterKodlar?.includes(item.kod)
      );
    } else {
      // Gönderilen kodlar ile uyuşmayanları filtreler
      this.dataSource = this.originalDataSource?.filter((item: any) =>
        !filterKodlar?.includes(item.kod)
      );
    }
  }

    setWidth(width: string) {
      this.selectBox.instance.option('width', width);
        }


  focusSelectBox() {
    setTimeout(() => this.selectBox?.instance?.focus());
  }

}
